import KBatch from './batch.vue'
export default KBatch
